import { createElement as h } from "react"

import { Icon as MuiIcon } from "@mui/material"
import { styled } from "@mui/styles"
import T from "prop-types"
import { and, isNil } from "ramda"
import { cx } from "ramda-extension/es"

import { Logic } from "@cirrus/fe-lib"

const StyledIcon = styled(MuiIcon)(({ theme: { typography, withPalette } }) => {
  return {
    "&.MuiIcon-root": ({ color, shade, size }) => ({
      alignItems: "center",
      color: withPalette(color, shade),
      display: "flex",
      fontSize: typography.pxToRem(size),
      height: typography.pxToRem(size),
      justifyContent: "center",
      speak: "none",
      width: typography.pxToRem(size),
    }),
  }
})

export const Icon = ({
  className,
  color = "#000000",
  customContent = "x",
  name,
  shade,
  size = 24,
}) =>
  h(
    StyledIcon,
    {
      className: cx(and(Logic.nullable(name), `icon icon-${name}`), className),
      color,
      shade,
      size,
    },
    isNil(name) ? customContent : null,
  )

Icon.propTypes = {
  className: T.string,
  color: T.string,
  customContent: T.string,
  name: T.string,
  shade: T.string,
  size: T.number,
}
